import { HOME_OFFERS_LIST,HOME_OFFERS_SUCCESS, HOME_OFFERS_ERROR} from "../../../redux/contants";

const INIT_STATE = {
    getHomeOffersList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case HOME_OFFERS_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case HOME_OFFERS_SUCCESS:
            console.log('HOME_OFFERS_SUCCESSS===',action);
            return {
                ...state,
                loading: false,
                getHomeOffersList: action.data,
                error: '',
                messages: ''
            };
        case HOME_OFFERS_ERROR:
            return {
                ...state,
                loading: false,
                getHomeOffersList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};